/**
 * Base React Query options for the main app.
 * Shared presets from @talleflow/query-presets (list respects staleTime on remount).
 *
 * Query key convention (see `.cursor/rules/frontend/react-query.mdc`):
 * - Query keys live under apps/web/src/hooks/ by domain (e.g. hooks/projects/, hooks/events/).
 * - Pattern: all, lists(), list(filters), details(), detail(id).
 */
import { commonQueryOptions as shared } from '@talleflow/query-presets';

export const commonQueryOptions = {
  ...shared,
};
